import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  icon: {
    display: 'inline-block',
    height: '8.07vh',
    width: '5.27vw',
    marginTop: '13.6vh',
    marginBottom: '6.74vh',
    color: themeColor.alert,
  },
  iconWarning: {
    display: 'inline-block',
    height: '8.07vh',
    width: '8.07vh',
    marginTop: '13.86vh',
    marginBottom: '2em',
    color: themeColor.warning,
  },
  title: {
    display: 'inline-block',
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '3.64vh',
    letterSpacing: '0.03vw',
    fontSize: vh(3.12),
    marginBlockStart: 0,
    marginBlockEnd: '0.91vh',
    color: themeColor.modalTitle,
  },
  message: {
    lineHeight: '3.64vh',
    letterSpacing: '0.04vw',
    color: themeColor.blackish,
    fontSize: vh(2.34),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
  },
  flex: {
    display: 'flex',
  },
}));
